import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface WarningIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const ExclamationMarkIcon = observer(
    'ExclamationMarkIcon',
    ({ className, onClick }: WarningIconPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                onClick={onClick}
                width='33'
                height='32'
                viewBox='0 0 33 32'
                xmlns='http://www.w3.org/2000/svg'
                data-test='exclamation-mark-icon'
            >
                <path
                    d='M16.4993 22.6667C16.8771 22.6667 17.1938 22.5389 17.4494 22.2833C17.7049 22.0278 17.8327 21.7111 17.8327 21.3333C17.8327 20.9556 17.7049 20.6389 17.4494 20.3833C17.1938 20.1278 16.8771 20 16.4993 20C16.1216 20 15.8049 20.1278 15.5493 20.3833C15.2938 20.6389 15.166 20.9556 15.166 21.3333C15.166 21.7111 15.2938 22.0278 15.5493 22.2833C15.8049 22.5389 16.1216 22.6667 16.4993 22.6667ZM15.166 17.3333H17.8327V9.33334H15.166V17.3333ZM16.4993 29.3333C14.6549 29.3333 12.9216 28.9833 11.2993 28.2833C9.67713 27.5833 8.26602 26.6333 7.06602 25.4333C5.86602 24.2333 4.91602 22.8222 4.21602 21.2C3.51602 19.5778 3.16602 17.8444 3.16602 16C3.16602 14.1556 3.51602 12.4222 4.21602 10.8C4.91602 9.17778 5.86602 7.76667 7.06602 6.56667C8.26602 5.36667 9.67713 4.41667 11.2993 3.71667C12.9216 3.01667 14.6549 2.66667 16.4993 2.66667C18.3438 2.66667 20.0771 3.01667 21.6994 3.71667C23.3216 4.41667 24.7327 5.36667 25.9327 6.56667C27.1327 7.76667 28.0827 9.17778 28.7827 10.8C29.4827 12.4222 29.8327 14.1556 29.8327 16C29.8327 17.8444 29.4827 19.5778 28.7827 21.2C28.0827 22.8222 27.1327 24.2333 25.9327 25.4333C24.7327 26.6333 23.3216 27.5833 21.6994 28.2833C20.0771 28.9833 18.3438 29.3333 16.4993 29.3333Z'
                    fill='white'
                />
            </SvgElement>
        );
    }
);
